import { lazy, number, object } from "yup";

const getUserAnswersSchema = () =>(
    object({
        userAnswers: lazy((values) => {
            const newEntries = Object.keys(values).reduce(
                (accumulator, currentValue) => {
                    return ({
                        ...accumulator,
                        [currentValue]: number().min(0).max(4).required()
                    })
                },
              {},
            )
            return object().shape(newEntries).noUnknown()
        }),
    })
)

export default getUserAnswersSchema